<script>
import XmlChannelStatusCardHeader from './XmlChannelStatusCardHeader';
import dateMixin from '../../mixins/dateMixin';

export default {
  name: 'XmlChannelStatusXmlCard',
  components: {
    XmlChannelStatusCardHeader,
  },
  mixins: [
    dateMixin,
  ],
  props: {
    xmlChannel: {
      type: Object,
      required: true,
    },
  },
  methods: {
    openJobList(xmlChannel) {
      this.$emit('open-job-list', xmlChannel);
    },
    openSchedule(xmlChannel) {
      this.$emit('open-schedule', xmlChannel);
    },
    activateLatestJob(xmlChannel) {
      this.$emit('activate-latest-job', xmlChannel);
    },
  },
};
</script>

<template>
  <v-flex v-if="xmlChannel.latestJob">
    <xml-channel-status-card-header :xml-channel="xmlChannel"/>
    <v-divider class="mx-2"/>
    <v-card-text class="title">
      {{ $t('xmlChannelStatus.xmlChannelStatusCard.latestJob') }}
    </v-card-text>
    <v-card-text class="pt-0 pb-1">
      <span>
        <strong>{{ $t('xmlChannelStatus.xmlChannelStatusCard.receivedPrices') }}:</strong>
      </span>
      <span>{{ xmlChannel.latestJob.rows }}</span>
    </v-card-text>
    <v-card-text class="pt-0 pb-1">
      <span>
        <strong>{{ $t('xmlChannelStatus.xmlChannelStatusCard.importStarted') }}:</strong>
      </span>
      <span>{{  formatDate(xmlChannel.latestJob.runStart) }}</span>
    </v-card-text>
    <v-card-text class="pt-0 pb-1">
      <span>
        <strong>{{ $t('xmlChannelStatus.xmlChannelStatusCard.importFinished') }}:</strong>
      </span>
      <span v-if="xmlChannel.latestJob.runEnd">
        {{ formatDate(xmlChannel.latestJob.runEnd) }}
        ({{ getFormattedDuration(xmlChannel.latestJob.runStart, xmlChannel.latestJob.runEnd) }})
      </span>
      <span v-else class="pl-2">-</span>
    </v-card-text>
    <v-divider class="mx-2 pt-1"/>
    <v-btn @click="openJobList(xmlChannel)" color="primary" outline small>
      {{ $t('xmlChannelStatus.xmlChannelStatusCard.jobList') }}
    </v-btn>
    <v-btn @click="openSchedule(xmlChannel)" color="secondary" outline small>
      {{ $t('xmlChannelStatus.xmlChannelStatusCard.schedule') }}
    </v-btn>
    <v-btn
      v-if="xmlChannel.latestJob.status === 'WARNING'"
      @click="activateLatestJob(xmlChannel)"
      :color="`${xmlChannel.latestJob.rows > 0 ? 'success' : 'warning' }`"
      small
    >
      Activate
    </v-btn>
  </v-flex>
  <v-flex v-else>
    <v-card-title dark>
      {{ xmlChannel.webservice }}
      <v-spacer />
      <small>{{ xmlChannel.system }}</small>
      <v-spacer />
      <badge :badge="badges['NO_CONTENT']"/>
    </v-card-title>
  </v-flex>
</template>



// WEBPACK FOOTER //
// src/components/xmlChannelStatus/XmlChannelStatusXmlCard.vue